import { create } from 'zustand';

function readEnabled(): boolean {
  try { return localStorage.getItem('consoleLog.enabled') === 'true'; } catch { return false; }
}

interface ConsoleLogStoreState {
  enabled: boolean;
  setEnabled: (v: boolean) => void;
}

export const useConsoleLogStore = create<ConsoleLogStoreState>((set) => ({
  enabled: readEnabled(),
  setEnabled: (enabled) => {
    try { localStorage.setItem('consoleLog.enabled', enabled ? 'true' : 'false'); } catch { /* ignore */ }
    set({ enabled });
  },
}));
